import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=a2334b5a&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=a2334b5a&prod&lang=css"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=a2334b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2334b5a",
  null
  
)

export default component.exports